/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { IScreen } from './interfaces';

export class Screen<T> implements IScreen<T> {
    private readonly mIdentifier: string;

    private mProperties: T | null;

    public constructor(identifier: string) {
        this.mIdentifier = identifier;
        this.mProperties = null;
    }

    public getIdentifier(): string {
        return this.mIdentifier;
    }

    public getProperties(): T | null {
        return this.mProperties;
    }

    public setProperties(properties: T): void {
        this.mProperties = properties;
    }
}
